import styled from "styled-components";

// main header
export const Container = styled.div`
  padding: 2.1rem 3.2rem;
  .inner {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .logo {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      .icon-box {
        width: 3.5rem;
        height: 3.4rem;
        img {
          max-width: 100%;
        }
      }
      .img-box {
        width: 17.6rem;
        display: flex;
        img {
          max-width: 100%;
        }
      }
    }
    .sub {
      display: flex;
      gap: 1.6rem;
      span {
        font-size: 1.6rem;
        letter-spacing: -0.05rem;
        font-family: "Pretendard";
        font-weight: 500;
        cursor: pointer;
        &.hr {
          height: 1.2rem;
          width: 1px;
          background-color: #9a9a9a;
          transform: translateY(3px);
        }
      }
    }

    .mobile-menu {
      display: none;
    }

    /* 햄버거 메뉴 기본 스타일 */
    .hamburger-menu {
      display: none;
      cursor: pointer;
      width: 25px; /* 아이콘 크기 */
      height: 25px; /* 아이콘 높이 */
      position: relative;
    }

    .hamburger-menu .bar {
      width: 100%;
      height: 3px; /* 바 두께 */
      background-color: #333;
      margin: 5px 0;
      transition: transform 0.3s ease, opacity 0.3s ease; /* 부드러운 전환 */
    }
  }
  @media screen and (max-width: 768px) {
    padding: 2rem;
    .inner {
      .img-box {
        max-width: 14rem;
      }
      .hamburger-menu {
        display: block;
        z-index: 9999;
      }

      /* 햄버거 메뉴 클릭 시 X자 모양으로 변환 */
      .hamburger-menu.active .bar:nth-child(1) {
        transform: rotate(45deg); /* 첫 번째 바 회전 */
        position: absolute;
        top: 6px;
      }

      .hamburger-menu.active .bar:nth-child(2) {
        opacity: 0; /* 두 번째 바 숨김 */
      }

      .hamburger-menu.active .bar:nth-child(3) {
        transform: rotate(-45deg); /* 세 번째 바 회전 */
        position: absolute;
        bottom: 6px;
      }

      .mobile-menu {
        position: fixed;
        top: 0;
        right: 0;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
        z-index: 100;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        display: flex;
        justify-content: flex-end;
        span {
          font-size: 20px;
        }
        .inner {
          width: 50%;
          height: 100%;
          background-color: #fff;
          display: flex;
          flex-direction: column;
          align-items: flex-end;
          justify-content: flex-start;
          border-radius: 10px 0 0 10px;
          padding: 70px 10px;
        }
      }

      .mobile-menu span {
        cursor: pointer;
        padding: 8px;
      }

      .mobile-menu span:hover {
        background-color: #f0f0f0;
      }

      .sub {
        display: none; /* 데스크탑 메뉴는 모바일에서는 숨김 */
      }
    }
  }
`;
